import { render, staticRenderFns } from "./google-sign-in.vue?vue&type=template&id=150cca9d&scoped=true"
import script from "./google-sign-in.vue?vue&type=script&lang=js"
export * from "./google-sign-in.vue?vue&type=script&lang=js"
import style0 from "./google-sign-in.vue?vue&type=style&index=0&id=150cca9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150cca9d",
  null
  
)

export default component.exports